module.exports = "/_next/static/images/DataPrivacy@2x-3f61a0b57fdb2ef950e3879af6716be8.webp";